module.exports = __webpack_public_path__ + "static/media/SBPhotography_1-763w.4ca5f457.webp";